(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController =
/*@ngInject;*/
function LoginController($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window, $localStorage) {
    var _this = this;

    _classCallCheck(this, LoginController);

    $scope.pages = 'login';
    $scope.registration = $location.search();

    var content = window.translations,
        customer_id = window.customer_id,
        tokens = window.tokens,
        register_postcode = window.register_postcode == 1 ? true : false,
        brand_code = window.brand_code,
        reg_code = window.reg_code,
        terms_of_privacy_document_update = window.terms_privacy_document_update;

    $scope.content = content;

    if ($localStorage.terms_of_privacy_update === undefined) {
        $localStorage.$default({
            terms_of_privacy_update: ""
        });
    }

    $scope.terms_of_privacy_update = $localStorage.terms_of_privacy_update === terms_of_privacy_document_update;

    this.user = new _User2.default();

    if (reg_code !== undefined) {
        $scope.member_id = reg_code.member_id;
        $scope.email = reg_code.email;
    }

    $scope.change_page = function (page) {
        $scope.registration.reg = 0;

        $scope.pages = page;
    };

    $scope.mailto = function (email) {
        window.location.href = 'mailto:' + email;
    };

    $('[data-toggle="popover"]').popover({ trigger: "hover" });

    if (register_postcode !== false) {
        $('#main-register-form').css('opacity', '0.5');
        $('#main-register-form button').attr('disabled', 'disabled');
        $('#main-register-form input').each(function () {
            $(this).attr('disabled', 'disabled');
        });

        var inputMemberId = $('input[name="member_id"]'),
            inputPostcode = $('input[name="postcode"]');

        inputMemberId.attr('maxlength', '8');
        inputPostcode.attr('maxlength', '5');

        var user = this.user,
            count = 0;

        $('.member_id_postcode').on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));

            if (event.which < 48 || event.which > 57) {
                event.preventDefault();
            }

            if (inputMemberId.val().length == 8 && inputPostcode.val().length == 5) {
                if (count == 0) {
                    count += 1;

                    $('.member_id_postcode').attr('disabled', 'disabled');
                    $('img.spinner').css('visibility', 'visible');

                    var data = {
                        member_id: inputMemberId.val(),
                        postcode: inputPostcode.val()
                    };

                    user.checkMembership(data).then(function (value) {
                        $('img.spinner').css('visibility', 'hidden');

                        if (value.success) {
                            $('#main-register-form').css('opacity', '1');
                            $('#main-register-form button').removeAttr('disabled');
                            $('#main-register-form input').each(function () {
                                $(this).removeAttr('disabled');
                            });
                        } else {
                            count = 0;

                            $('.member_id_postcode').removeAttr('disabled');

                            swal({
                                title: content['error-swal-title'],
                                text: value.message,
                                type: 'error'
                            });
                        }
                    });
                }
            }
        });
    }

    $scope.set_guest_password = function ($event) {
        var password = $scope.password !== "" && $scope.password !== undefined ? $scope.password : false,
            password_conf = $scope.password_conf !== "" && $scope.password_conf !== undefined ? $scope.password_conf : false,
            tnc = $scope.tnc !== undefined ? $scope.tnc : false,
            error = false,
            url = '/user/guest-password/' + customer_id + '/' + tokens.token + '/' + window.tokens.token_id,
            valid = true;

        policies.forEach(function (value) {
            if (!value.status) {
                valid = false;
                error = content['registration-health-checker-error'];
            }
        });

        if (!tnc) {
            valid = false;
            error = content['error-accept-terms-conditions'];
        }

        if (!valid) {
            swal({
                title: content['error-swal-title'],
                text: error,
                type: 'error'
            });
        } else {
            $scope.guest_password_load = true;

            var data = {
                password: password,
                password_conf: password_conf,
                tnc: tnc
            };

            _this.user.setGuestPassword(data, url).then(function (value) {
                $timeout(function () {
                    $scope.guest_password_load = false;
                }, 100);

                if (!value.success) {
                    swal({
                        title: content['error-swal-title'],
                        text: value.error[0],
                        type: 'error'
                    });
                }

                if (value.success === true) {
                    swal({
                        title: content['guest-password-set-title'],
                        text: content['guest-password-set-text'],
                        type: 'success'
                    }).then(function () {
                        $window.location.href = '/user/login';
                    });
                }
            });
        }
    };

    $scope.forgot_password = function ($event) {
        var form = $($event.target),
            input = form.find('input[name="email"]'),
            data = {
            email: $scope.forgot_email
        };

        $scope.forgot_password_load = true;

        _this.user.forgotPassword(data).then(function (value) {
            $scope.$apply(function () {
                $scope.forgot_password_load = false;
            });

            if (value.success) {
                swal({
                    title: content['reset-email-sent-title'],
                    text: content['reset-email-sent-text'],
                    type: 'success'
                });

                input.val("");
            } else {
                swal({
                    title: content['error-swal-text'],
                    text: content['error-occurred'],
                    type: 'error'
                });
            }
        });
    };

    $scope.login = function ($event) {
        var valid = true,
            error = "",
            data = {
            "username": $scope.username,
            "password": $scope.password
        };

        if ($scope.username == '' || $scope.username === undefined || $scope.password == '' || $scope.password === undefined) {
            valid = false;

            error = content['error-fill-all-fields'];
        }

        if (!$scope.terms_of_privacy_update) {
            data['tc-accept'] = 0;

            if ($scope.tnc !== true) {
                valid = false;

                error = content['terms-update-text'];
            } else {
                data['tc-accept'] = 1;
            }
        }

        if (valid === true) {
            $scope.login_submit_load = true;

            _this.user.login(data).then(function (response) {
                if (response.success) {
                    $localStorage.terms_of_privacy_update = terms_of_privacy_document_update;

                    $window.location.href = '/user/dashboard';
                } else {
                    $scope.$apply(function () {
                        $scope.login_submit_load = false;
                    });

                    swal({
                        title: content['error-swal-title'],
                        html: response.error,
                        type: 'error'
                    });
                }
            });
        } else {
            swal({
                title: content['error-swal-title'],
                html: error,
                type: 'error'
            });
        }
    };

    $scope.register = function ($event) {
        var form = $($event.target),
            valid = true,
            error = "",
            data = {
            "tc-accept": 0,
            "password": $scope.password,
            "password_conf": $scope.rpassword,
            "email": $scope.email,
            "enroled_identifier": $scope.member_id
        };

        if ($scope.first_name !== undefined) {
            data.first_name = $scope.first_name;
            data.last_name = $scope.last_name;
        }

        if ($scope.member_id == '' || $scope.member_id === undefined || $scope.email == '' || $scope.email === undefined || $scope.password == '' || $scope.password === undefined) {
            valid = false;

            error = content['error-fill-all-fields'];
        }

        if ($scope.tnc !== true) {
            valid = false;

            error = content['error-accept-terms-conditions'];
        }

        policies.forEach(function (value) {
            if (!value.status) {
                valid = false;

                error = content['registration-health-checker-error'];
            }
        });

        if (valid === true) {
            $scope.register_submit_load = true;

            data['tc-accept'] = 1;

            _this.user.register(data).then(function (value) {
                if (value.success) {
                    $window.location.href = '/user/login';
                } else {
                    $scope.$apply(function () {
                        $scope.register_submit_load = false;
                    });

                    swal({
                        title: content['error-swal-title'],
                        html: value.error[0],
                        type: 'error'
                    });
                }
            });
        } else {
            swal({
                title: content['error-swal-title'],
                text: error,
                type: 'error'
            });
        }
    };

    $scope.reset_password = function ($event) {
        var form = $($event.target),
            abs_url = $location.absUrl(),
            url = abs_url.substring(abs_url.indexOf('/user/')),
            data = {
            password: $scope.password,
            password_conf: $scope.password_conf
        },
            valid = true;

        policies.forEach(function (value) {
            if (!value.status) {
                valid = false;
            }
        });

        if (!valid) {
            swal({
                title: content['error-swal-title'],
                text: content['registration-health-checker-error'],
                type: 'error'
            });
        } else {
            $scope.reset_password_load = true;

            _this.user.resetPassword(data, url).then(function (value) {
                $scope.$apply(function () {
                    $scope.reset_password_load = false;
                });

                if (value.success) {
                    $window.location.href = '/user/login';
                } else {
                    swal({
                        title: content['error-swal-title'],
                        text: value.error[0],
                        type: 'error'
                    });
                }
            });
        }
    };
};

exports.default = LoginController;

},{"../models/User":10}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Assistance = require('../models/Assistance');

var _Assistance2 = _interopRequireDefault(_Assistance);

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

var _Monitoring = require('../models/Monitoring');

var _Monitoring2 = _interopRequireDefault(_Monitoring);

var _Dials = require('../models/Dials');

var _Dials2 = _interopRequireDefault(_Dials);

var _Download = require('../models/Download');

var _Download2 = _interopRequireDefault(_Download);

var _ResolutionCenter = require('../models/ResolutionCenter');

var _ResolutionCenter2 = _interopRequireDefault(_ResolutionCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PortalController = function () {
    /*@ngInject;*/
    function PortalController($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
        var _this = this;

        _classCallCheck(this, PortalController);

        var content = window.translations,
            isMobile = window.isMobile === true ? true : false,
            faqs,
            assistance,
            dial_colors = window.dial_colors,
            tutorial = window.tutorial,
            tutorial_video = window.tutorial_video,
            customer = window.customer,
            home_address_order = window.home_address_order,
            css_arrow_pos = window.css_arrow_pos,
            monitoring_fields = window.monitoring_fields,
            brandCode = window.brand_code,
            member_id = window.member_id,
            computer_type = window.computer_type !== undefined ? window.computer_type : 'pc',
            cpf_number = ['ca_carrefour_br', 'ca_atacadao_br'],
            scrollTime = 0.3,
            scrollDistance = 130,
            resCenter,
            table;

        $scope.ignore_feature = window.ignore_feature;

        $scope.notification = 0;

        $scope.modal_assist = "";

        /*$scope.monitoring_dial_value = 4;
          setTimeout(()=> {
            $scope.$apply(function() {
                $scope.monitoring_dial_value = 6;
            })
        }, 2000)*/

        $scope.mobile_dashboard_icons = {
            identity_risk: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#dashboard" /></svg>'),
            data_moniotring: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#shield-4" /></svg>'),
            assistance: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#telemarketer" /></svg>'),
            faqs: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#questions-circular-button" /></svg>')
        };

        if (brandCode === 'ea_gma_ch') {
            $scope.mobile_dashboard_icons = {
                identity_risk: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#identity" /></svg>'),
                data_moniotring: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#shield" /></svg>'),
                assistance: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#assistance-2" /></svg>'),
                faqs: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#faqs" /></svg>')
            };
        }

        var assist_modal = $('#modal-assist-info');

        //Scrolling window smoothness
        $('.page-wrapper.canvas').on("mousewheel DOMMouseScroll", function (event) {
            event.preventDefault();

            var delta = event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
            var scrollTop = $($window).scrollTop();
            var finalScroll = scrollTop - parseInt(delta * scrollDistance);

            TweenMax.to($window, scrollTime, {
                scrollTo: { y: finalScroll, autoKill: true },
                ease: Power1.easeOut,
                autoKill: true,
                overwrite: 5
            });
        });

        $scope.mailto = function (email) {
            window.location.href = 'mailto:' + email;
        };

        var iframe = {
            markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>' + '</div>',
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1&rel=0&ytp-pause-overlay=0'
                }
            },
            srcAction: 'iframe_src'
        };

        $('.popup-video').magnificPopup({
            type: 'iframe',
            iframe: iframe
        });

        $('.popup-video').click(function () {
            $('#leftMenu').offcanvas('hide');
        });

        $('body').on("keypress keyup blur", 'input[data-input-type="numeric"]', function (event) {
            if (event.which < 48 || event.which > 57) {
                event.preventDefault();
            }
        });

        $('body').on("keypress", 'input[data-input-type="numeric_phone"]', function (event) {
            if (event.which != 43) {
                if (event.which < 48 || event.which > 57) {
                    event.preventDefault();
                }
            }
        });

        if (tutorial !== false) {
            if (tutorial == 0) {
                $timeout(function () {
                    $.magnificPopup.open({
                        items: { src: tutorial_video },
                        type: 'iframe',
                        iframe: iframe
                    });
                }, 1000);
            }
        }

        $timeout(function () {
            $('.panel-collapse').on('show.bs.collapse', function (event) {
                var self = $(event.target),
                    faq_icon = self.parent('div').find('.panel-title span.faq-icon'),
                    faq_arrow = self.parent('div').find('.panel-title span.faq-arrow');

                faq_arrow.addClass('up');
                faq_icon.removeClass('fa-plus-circle');
                faq_icon.addClass('fa-minus-circle');
            });

            $('.panel-collapse').on('hide.bs.collapse', function (event) {
                var self = $(event.target),
                    faq_icon = self.parent('div').find('.panel-title span.faq-icon'),
                    faq_arrow = self.parent('div').find('.panel-title span.faq-arrow');

                faq_arrow.removeClass('up');
                faq_icon.removeClass('fa-minus-circle');
                faq_icon.addClass('fa-plus-circle');
            });
        }, 100);

        this.curr_language = window.curr_language;

        $scope.content = content;

        $scope.cpf_checkbox = false;

        this.monitoring = new _Monitoring2.default($http, customer, content, isMobile, $sce, home_address_order, monitoring_fields, member_id);

        $scope.initMobileDataMonitoringPage = function () {
            $scope.initDashboard();

            var originalPath = $route.current.originalPath;

            if (originalPath == '/data-monitoring') {
                $scope.getMonitoringDetails().then(function (value) {
                    $scope.$apply(function () {
                        $scope.monitor_add_edit_form = value;
                    });
                });
            }

            $timeout(function () {
                var headerHeight = $('#m_header').height() + 20,
                    mBodyMarginTop = parseInt($('.m-body').css('margin-top'));

                //Adjust margin-top if header is too large
                if (headerHeight > mBodyMarginTop) {
                    $('.m-body').css('margin-top', headerHeight + 20);
                }
            }, 100);
        };

        var trackColor = '#9B9B9B',
            trackWidth = 1,
            arcBorder = false,
            arcColor = '#FFFFFF',
            smallDialTrackColor = '#ECECEC';

        if (brandCode == 'ea_gma_ch') {
            trackColor = dial_colors[0];
            trackWidth = 3;
            arcBorder = true;
            arcColor = '#7f9fa9';
            smallDialTrackColor = arcColor;
        }

        $scope.initDashboard = function () {
            assistance = new _Assistance2.default(window.assistance, window.scan_policy);
            faqs = window.faqs;

            $scope.faqs = faqs;
            $scope.assistance = window.assistance;

            for (var i in $scope.faqs) {
                if (typeof $scope.faqs[i].description == 'string') {
                    $scope.faqs[i].description = $sce.trustAsHtml(faqs[i].description);
                }
            }

            if (isMobile) {
                $('html, body').animate({
                    scrollTop: 0
                }, 0);

                var notificationElem = $('.notification');

                notificationElem.find('.counter').css('background', dial_colors[2]);

                setTimeout(function () {
                    var panelPosition = $('div.panel-body').position(),
                        startOffDistance = panelPosition.top - $(window).scrollTop();

                    if (startOffDistance <= 20) {
                        startOffDistance = 20;
                    }

                    notificationElem.css({
                        'top': startOffDistance + 'px'
                    });

                    $(window).scroll(function () {
                        var distance = panelPosition.top - $(window).scrollTop();

                        if (distance <= 20) {
                            distance = 20;
                        }

                        notificationElem.css({
                            'top': distance + 'px'
                        });
                    });
                }, 500);

                var abs_url = $location.absUrl(),
                    url = abs_url.substring(abs_url.indexOf('?'), abs_url.indexOf('#!/'));

                $scope.url_prefix = url;
            }

            _this.dials = new _Dials2.default(270, 170, content, dial_colors);
            _this.download = new _Download2.default($sce, content, window.deviceDisplayCount);
            _this.resCenter = new _ResolutionCenter2.default(window.resolution_initial_list, content, $sce);

            $scope.request_assistance = _this.resCenter.getRequestList();
            $scope.request_assistance_selected_key = 0;

            $scope.risk_level_dial = _this.dials.risk_level_dial(window.overallScore.overall, window.overallScore.risk, trackColor, trackWidth, arcBorder, arcColor);

            $scope.monitoring_dial = _this.createMonitoringDial(window.assetScores.assetPercent, window.assetScores.assetCount);

            $scope.personal_dial = _this.dials.small_dial(0, 0, smallDialTrackColor);
            $scope.finance_dial = _this.dials.small_dial(0, 0, smallDialTrackColor);
            $scope.dark_web_dial = _this.dials.small_dial(0, 0, smallDialTrackColor);

            $scope.getIdentityRiskDetails('monitor_load_0', $('#identity-fraud-page'), true, true);

            (function (monitoring) {
                $(document).off('click', 'svg.assist-info');
                $(document).on('click', 'svg.assist-info', function () {
                    var assist_where = $(this).attr('assist-where'),
                        assist_found = $(this).attr('assist-found'),
                        row_id = $(this).attr('assist-row-id');

                    var row = table.row(row_id).data();

                    if (row.help_opened == 0) {
                        row.help_opened = 1;

                        $(this).parents('tr').find('td').css('font-weight', 'normal');

                        var post = { id: row.hit_id };

                        monitoring.updateScanResultSurvive(post);
                    }

                    $scope.$apply(function () {
                        $scope.modal_assist = assistance.create(assist_where, assist_found);
                    });

                    assist_modal.modal('toggle');
                });

                $(document).on('click', '.btn[data-type=_ignore]', function () {
                    var id = parseInt($(this).attr('data-id'));

                    sweetAlert({
                        title: content['identity-fraud-page-ignore-confirm-title'],
                        text: content['identity-fraud-page-ignore-confirm-text'],
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: content['identity-fraud-page-cancel-action'],
                        confirmButtonText: content['identity-fraud-page-ignore-action']
                    }).then(function (result) {
                        // force the closing of tooltip to avoid "hanging"
                        $('[data-toggle="tooltip"]').tooltip('hide');

                        if (result.value) {
                            $('#datatable-results').find('tbody').addClass('disabled');
                            return monitoring.ignoreScanRecord({ id: id });
                        }
                        return Promise.reject('Cancelled request.');
                    }).then(function (result) {
                        return $scope.getIdentityRiskDetails('monitor_load_0', $('#identity-fraud-page'), true, true);
                    }).then(function (result) {
                        $('#datatable-results').find('tbody').removeClass('disabled');
                    }).catch(function (error) {
                        $('#datatable-results').find('tbody').removeClass('disabled');
                        console.log(error);
                    });
                });
            })(_this.monitoring);

            var details = [{
                icon: 'flaticon-dashboard',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-identity-fraud-page-title']),
                text: content['monitor-step-identity-fraud-page-text'],
                items: 4,
                method: 'identity-fraud-page'
            }, {
                icon: 'flaticon-shield-4',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-monitoring-page-title']),
                text: content['monitor-step-monitoring-page-text'],
                items: 2,
                method: 'monitoring-page'
            }, {
                icon: 'flaticon-technology-3',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-download-page-' + computer_type + '-title']),
                text: content['monitor-step-download-page-' + computer_type + '-text'],
                items: 4,
                method: 'download-page-pc'
            }, {
                icon: 'flaticon-devices-1',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-download-page-mobile-title']),
                text: content['monitor-step-download-page-mobile-text'],
                items: 4,
                method: 'download-page-mobile'
            }, {
                icon: 'flaticon-telemarketer',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-identity-assistance-title']),
                text: content['monitor-step-identity-assistance-text'],
                items: 0,
                method: 'identity-assistance'
            }, {
                icon: 'flaticon-questions-circular-button',
                icon_type: 'flaticon',
                title: $sce.trustAsHtml(content['monitor-step-faqs-page-title']),
                text: content['monitor-step-faqs-page-text'],
                items: 0,
                method: 'faqs-page'
            }];

            if (brandCode == 'ea_generic_ru') {
                for (var _i in details) {
                    if (details[_i].method == 'identity-assistance') {
                        details[_i].icon = '<svg class="flag-icon email-2"><use xlink:href="#email-2" /></svg>';
                        details[_i].icon_type = 'svg';
                    }
                }
            }

            if (brandCode === 'ea_gma_ch') {
                var svg_icon = '';

                for (var _i2 in details) {
                    switch (details[_i2].method) {
                        case 'identity-fraud-page':
                            svg_icon = 'identity';
                            break;
                        case 'monitoring-page':
                            svg_icon = 'shield';
                            break;
                        case 'download-page-pc':
                            svg_icon = 'laptop-3';
                            break;
                        case 'download-page-mobile':
                            svg_icon = 'mobile-2';
                            break;
                        case 'identity-assistance':
                            svg_icon = 'assistance-2';
                            break;
                        case 'faqs-page':
                            svg_icon = 'faqs';
                            break;
                    }

                    details[_i2].icon = '<svg class="flag-icon"><use xlink:href="#' + svg_icon + '" /></svg>';
                    details[_i2].icon_type = 'svg';
                }
            }

            $scope.monitoring_details = [];

            if (window.monitoring_pages.length != details.length) {
                for (var index in window.monitoring_pages) {
                    for (var _i3 in details) {
                        if (details[_i3].method == window.monitoring_pages[index]) {
                            $scope.monitoring_details.push(details[_i3]);
                        }
                    }
                }
            } else {
                $scope.monitoring_details = details;
            }

            for (var i = 0; i < $scope.monitoring_details.length; i++) {
                $scope.monitoring_details[i].bg_color = 'bg-primary';

                if (i % 2 == 1) {
                    $scope.monitoring_details[i].bg_color = 'bg-primary-over';
                }
            }

            $scope.monitor_add_edit_form = _this.monitoring.add_edit_forms();

            $scope.monitor_breakdown = {
                enabled: false,
                personal_dial: ''
            };

            $scope.resolution_center = {
                select_option: [{ name: 'Choose one...' }],
                initial_list: _this.resCenter.getInitialList(),
                second_list: false,
                resolution: $sce.trustAsHtml('')
            };

            resCenter = _this.resCenter;
        };

        $scope.initMyAccount = function () {
            var user = new _User2.default($http),
                post = { sms: window.sms };

            $('input[name="sms"]').change(function ($event) {
                var checked = $(this).prop('checked');

                if (checked) {
                    post.sms = 1;

                    $('span.text-switch').html(content['form-sms-text-on']);
                } else {
                    post.sms = 0;

                    $('span.text-switch').html(content['form-sms-text-off']);
                }
            });

            $scope.edit_profile = function ($event) {
                var form = $($event.target),
                    profile_update = true;

                $scope.update_profile_load = true;

                form.find('input').each(function () {
                    var input = $(this),
                        input_name = input.attr('name');

                    if (input_name != 'sms') {
                        post[input_name] = input.val();
                    }
                });

                if (post.phone != "" && post.phone != undefined) {
                    var firstchar = post.phone.charAt(0);

                    if (firstchar !== '+') {
                        profile_update = false;

                        $scope.update_profile_load = false;

                        swal({
                            title: content['error-swal-title'],
                            text: content['error-swal-phone-country-code'],
                            type: 'error'
                        });
                    }
                }

                if (post.sms) {
                    if (post.phone == "" || post.phone == undefined) {
                        profile_update = false;

                        $scope.update_profile_load = false;

                        swal({
                            title: content['error-swal-title'],
                            text: content['error-swal-phone-sms'],
                            type: 'error'
                        });
                    }
                }

                if (profile_update) {
                    user.updateProfile(post).then(function (value) {
                        $scope.$apply(function () {
                            $scope.update_profile_load = false;
                        });

                        if (value.success) {
                            swal({
                                title: content['success-alert-title'],
                                text: content['success-alert-text'],
                                type: 'success'
                            });
                        }

                        if (!value.success) {
                            swal({
                                title: content['error-swal-title'],
                                text: value.error[0],
                                type: 'error'
                            });
                        }
                    });
                }
            };

            $scope.change_password = function ($event) {
                var post = {
                    current: $scope.change_password_current,
                    password: $scope.change_password_password,
                    confirm: $scope.change_password_confirm
                },
                    valid = true;

                policies.forEach(function (value) {
                    if (!value.status) {
                        valid = false;
                    }
                });

                if (!valid) {
                    swal({
                        title: content['error-swal-title'],
                        html: content['registration-health-checker-error'],
                        type: 'error'
                    });
                } else {
                    $scope.change_password_load = true;

                    user.changePassword(post).then(function (value) {
                        $scope.$apply(function () {
                            $scope.change_password_load = false;
                        });

                        if (value.success) {
                            swal({
                                title: content['change-password-swal-title'],
                                html: "", //content['change-password-swal-text'],
                                type: 'success'
                            }).then(function () {
                                //Once password has been successfully changed, go back to dashboard page
                                $window.location.href = '/user/dashboard';
                            });
                        }

                        if (!value.success) {
                            swal({
                                title: content['error-swal-title'],
                                html: value.error[0],
                                type: 'error'
                            });
                        }
                    });
                }
            };
        };

        var knobs = $('.panel-body.knobs');

        $scope.mtStepColHeight = 0;

        $timeout(function () {
            //$('[data-toggle="popover"]').popover({ trigger: "hover" });

            var numbers = [];

            $('.mt-step-col').each(function () {
                numbers.push($(this).height() + 45);
            });

            var largestNumber = Math.max.apply(Math, numbers);

            $scope.mtStepColHeight = largestNumber;

            $('.mt-step-col').css('height', largestNumber);
        }, 100);

        $scope.$watch('knobsHeight', function () {});

        $scope.aliasKeyPressEvent = function ($value, $key, $obj) {
            var pattern = '',
                new_value = $value,
                form_group = $($obj).parents('div.form-group');

            return new Promise(function (resolve, reject) {
                if ($key !== 'Backspace') {
                    switch ($value.length) {
                        case 2:
                            new_value = $value + '/';
                            resolve({ success: true, value: new_value });
                            break;

                        case 5:
                            new_value = $value + '/';
                            resolve({ success: true, value: new_value });
                            break;
                    }
                } else {
                    resolve(true);
                }

                if (new_value.length >= 10) {
                    pattern = /^([0-3]{1}[0-9]{1})\/([0-1]{1}[0-9]{1})\/([0-9]{4})$/;

                    if (pattern.test(new_value)) {
                        form_group.addClass('success');
                    } else {
                        form_group.addClass('error');
                    }

                    resolve(false);
                } else {
                    form_group.removeClass('error');
                    form_group.removeClass('success');
                }
            });
        };

        $scope.creditCardExpiry = function ($value, $key, $obj) {
            var pattern = '',
                new_value = $value,
                form_group = $($obj).parents('div.form-group');

            return new Promise(function (resolve, reject) {
                if ($key !== 'Backspace') {
                    switch ($value.length) {
                        case 2:
                            new_value = $value + '/';
                            resolve({ success: true, value: new_value });
                            break;
                    }
                } else {
                    resolve(true);
                }

                if (new_value.length >= 7) {
                    pattern = /^([0-3]{1}[0-9]{1})\/([0-9]{4})$/;

                    if (pattern.test(new_value)) {
                        form_group.addClass('success');
                    } else {
                        form_group.addClass('error');
                    }

                    resolve(false);
                } else {
                    form_group.removeClass('error');
                    form_group.removeClass('success');
                }
            });
        };

        $('#leftMenu').on('show.bs.offcanvas', function () {
            $('body .page-wrapper').bind('touchmove', function (e) {
                e.preventDefault();
            });

            $('.page-wrapper').click(function () {
                $('#leftMenu').offcanvas('hide');
            });
        });

        $('#leftMenu').on('hide.bs.offcanvas', function () {
            $('body .page-wrapper').unbind('touchmove');
            $('.page-wrapper').unbind('click');
        });

        $scope.monitor_action = function (name, self, ladda_desc) {
            var obj = $('#' + name),
                monitorForm = $('#monitor-form'),
                height = obj.height(),
                block = self !== undefined ? $(self.target).parents('.mt-step-col') : false,
                stepCol;

            monitorForm.find('.monitor-form').each(function () {
                if ($(this).css('display') != 'none' && $(this).attr('id') != name) {
                    stepCol = $(this);
                }
            });

            if (obj.css('display') == 'none') {
                $scope[ladda_desc] = true;

                $('.mt-step-col').each(function () {
                    $(this).find('.icon-arrow-down').css({
                        'bottom': 0,
                        'visibility': 'hidden'
                    });
                });
            }

            if (obj.css('display') == 'none') {
                if (name == 'identity-fraud-page') {
                    $scope.getIdentityRiskDetails(ladda_desc, obj, block).then(function (value) {
                        stepCol.animate({
                            height: "toggle"
                        }, 100, function () {});

                        $scope.scroll_to('monitor-form');
                    });
                }

                if (name == 'monitoring-page') {
                    $scope.getMonitoringDetails().then(function (v) {
                        $scope.$apply(function () {
                            $scope[ladda_desc] = false;

                            $scope.monitor_add_edit_form = v;

                            if (block !== false) {
                                if (obj.css('display') == 'none') {
                                    block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
                                        'visibility': 'visible'
                                    });
                                }
                            }

                            stepCol.animate({
                                height: "toggle"
                            }, 100, function () {});

                            obj.animate({
                                display: 'block',
                                height: "toggle"
                            }, 100);

                            $scope.scroll_to('monitor-form');
                        });
                    });
                }

                if (name == 'download-page-pc') {
                    var that = _this,
                        device = window.ua_platform,
                        devices = JSON.parse(window.odp_devices_allowed);

                    _this.download.getInstallCount(device).then(function (value) {
                        $scope.$apply(function () {
                            var dpsCount = value.dpsCount;

                            if (window.deviceDisplayCount > 3) {
                                that.download.software[device][0].installs = dpsCount;
                                that.download.software[device][1].installs = window.deviceDisplayCount - dpsCount;
                            } else {
                                for (var i = 0; i < dpsCount; i++) {
                                    that.download.software[device][i].protected = true;
                                }
                            }

                            $scope.downloads = that.download.setProtectedSoftware(device);

                            $scope.download_guide = content['download-' + computer_type + '-how-to-download-guide'];

                            $scope[ladda_desc] = false;

                            if (block !== false) {
                                if (obj.css('display') == 'none') {
                                    block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
                                        'visibility': 'visible'
                                    });
                                }
                            }

                            stepCol.animate({
                                height: "toggle"
                            }, 100, function () {});

                            obj.animate({
                                display: 'block',
                                height: "toggle"
                            }, 100);
                        });
                    });

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'download-page-mobile') {
                    var _that = _this,
                        _device = 'mobile';

                    _this.download.getInstallCount(_device).then(function (value) {
                        $scope.$apply(function () {
                            var mssCount = value.mssCount;

                            if (window.deviceDisplayCount > 3) {
                                _that.download.software[_device][0].installs = mssCount;
                                _that.download.software[_device][1].installs = window.deviceDisplayCount - mssCount;
                            } else {
                                for (var i = 0; i < mssCount; i++) {
                                    _that.download.software[_device][i].protected = true;
                                }
                            }

                            $scope.downloads = _that.download.setProtectedSoftware(_device);

                            //$scope.downloads[device].available = (window.deviceDisplayCount - mssCount);

                            $scope[ladda_desc] = false;

                            if (block !== false) {
                                if (obj.css('display') == 'none') {
                                    block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
                                        'visibility': 'visible'
                                    });
                                }
                            }

                            stepCol.animate({
                                height: "toggle"
                            }, 100, function () {});

                            obj.animate({
                                display: 'block',
                                height: "toggle"
                            }, 100);
                        });
                    });

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'identity-assistance') {
                    $scope[ladda_desc] = false;

                    if (block !== false) {
                        if (obj.css('display') == 'none') {
                            block.find('.icon-arrow-down').css({
                                'bottom': css_arrow_pos,
                                'visibility': 'visible'
                            });
                        }
                    }

                    stepCol.animate({
                        height: "toggle"
                    }, 100, function () {});

                    obj.animate({
                        display: 'block',
                        height: "toggle"
                    }, 100);

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'faqs-page') {
                    $scope[ladda_desc] = false;

                    if (block !== false) {
                        if (obj.css('display') == 'none') {
                            block.find('.icon-arrow-down').css({
                                'bottom': css_arrow_pos,
                                'visibility': 'visible'
                            });
                        }
                    }

                    stepCol.animate({
                        height: "toggle"
                    }, 100, function () {});

                    obj.animate({
                        display: 'block',
                        height: "toggle"
                    }, 100);

                    $scope.scroll_to('monitor-form');
                }
            }
        };

        $scope.delete_monitor_info = function (sd_id, p_id, type, $event, monitor_id) {
            swal({
                title: content['delete-monitor-txt'] + '?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: content['delete-monitor-txt'],
                cancelButtonText: content['cancel-monitor-txt'],
                confirmButtonColor: '#10BAEA',
                cancelButtonColor: '#55585C'
            }).then(function (willDelete) {
                if (willDelete.value === true) {
                    var self = $($event.target).parents('.block'),
                        form_group = $($event.target).parents('.form-group'),
                        post = {
                        data1: {}
                    };

                    switch (type) {
                        case 'address':
                            post.data1.address = true;
                            post.data1.addr1 = true;
                            post.data1.addr2 = true;
                            post.data1.addr3 = true;
                            post.data1.city = true;
                            post.data1.postcode = true;
                            post.data1.country = true;
                            post.data1['_sd_id-address'] = sd_id;
                            post.data1['_sd_id-addr1'] = sd_id;
                            post.data1['_sd_id-addr2'] = sd_id;
                            post.data1['_sd_id-addr3'] = sd_id;
                            post.data1['_sd_id-city'] = sd_id;
                            post.data1['_sd_id-postcode'] = sd_id;
                            post.data1['_sd_id-country'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'cc':
                            post.data1.credit_card = true;
                            post.data1.cc_expiry = true;
                            post.data1['_sd_id-credit_card'] = sd_id;
                            post.data1['_sd_id-cc_expiry'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'bank':
                            post.data1.bank_account = true;
                            post.data1.bank_code = true;
                            post.data1['_sd_id-bank_account'] = sd_id;
                            post.data1['_sd_id-bank_code'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'social_network':
                            post.data1['no-monitoring'] = 'social_network';
                            post.data1[type] = true;
                            post.data1['_sd_id-' + type] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        default:
                            post.data1[type] = true;
                            post.data1['_sd_id-' + type] = sd_id;
                            post.data1.p_id = p_id;
                    }

                    _this.monitoring.deleteAssetData(post).then(function (value) {
                        if (value.success) {
                            if (type === 'dob') {
                                form_group.removeClass('col-md-5');
                                form_group.addClass('col-md-6');
                                form_group.find('input').val('');
                                form_group.find('svg.dob-delete').remove();
                            }

                            _this.monitoring.getAssetData().then(function (data_value) {
                                $scope.$apply(function () {
                                    $scope.monitor_add_edit_form = data_value.forms;

                                    self.remove();

                                    $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                    $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                    $scope.risk_level_dial.value = data_value.risk_details.overall_score;

                                    var properties = _this.dials.set_dial_properties(data_value.risk_details.overall_risk),
                                        colors = ['#FFFFFF', '#FFFFFF', '#FFFFFF'];

                                    for (var i = 0; i <= properties.index; i++) {
                                        colors[i] = dial_colors[i];
                                    }

                                    $scope.risk_level_dial.options.displayDanger.text = content['risk-level-dial-txt-' + data_value.risk_details.overall_risk].toUpperCase();
                                    $scope.risk_level_dial.options.displayDanger.colors = colors;

                                    delete $scope.monitor_add_edit_form[monitor_id].fields[sd_id];
                                });
                            });
                        }
                    });
                }
            });
        };

        $scope.monitor_save_continue = function (obj, next_id) {
            var self = $(obj.target),
                form = self.parents('form');

            $scope.monitor_save(form, next_id);
        };

        $scope.monitor_save_cpf_number = function (obj, action) {
            var self = $(obj.target),
                form = self.parents('form');

            $scope.cpf_checkbox = action ? false : true;

            $scope.monitor_save(form);
        };

        $scope.monitor_save = function (obj) {
            var next_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = obj;

            if (_typeof(obj.target) === 'object') {
                self = $(obj.target);

                $scope.modal_save_btn = true;
            } else {
                $scope.modal_save_continue_btn = true;
            }

            var groups = self.find('.group'),
                input_values = {
                add: {},
                edit: {}
            },
                save_process = {
                count: 0,
                details: {}
            },
                modal = $('#modal-monitor-add-edit');

            groups.each(function (e) {
                var index = e += 1,
                    fields = $(this).find('input'),
                    labels = $(this).find('input[label=true]'),
                    label = $(this).find('input[name=_label]'),
                    type = $(this).attr('class').indexOf('add') !== -1 ? 'add' : 'edit',
                    sd_id = $(this).find('input[name=sd_id]').val();

                fields.each(function (e) {
                    var input = $(this),
                        value = input.val(),
                        input_name = input.attr('name'),
                        data = 'data' + index,
                        sd_id_name = '_sd_id-' + input_name;

                    if (input.attr('readonly') === undefined) {
                        if (input_values[type][data] === undefined) {
                            input_values[type][data] = {};
                        }

                        if (input_name != '_label' && input_name != 'sd_id') {
                            if (value !== 'undefined' && value !== '') {
                                input_values[type][data][input_name] = value;

                                if (input_name === 'email') {
                                    input_values[type][data]['isValid'] = /\S+@\S+\.\S+/.test(value);
                                }
                            }
                        }

                        if (type == 'edit' && input_name != '_label' && input_name != '_label-dob' && input_name != 'sd_id') {
                            input_values.edit[data][sd_id_name] = sd_id;
                        }

                        if (input_name === 'cpf_checkbox') {
                            input_values.add[data]['_label-passport'] = 'CPF Number';
                            input_values.add[data][sd_id_name] = sd_id;
                        }
                    }
                });

                labels.each(function (e) {
                    var input = $(this),
                        value = input.val(),
                        input_name = input.attr('name'),
                        data = 'data' + index,
                        label_tag = '_label-' + input_name;

                    if (value !== 'undefined' && value !== '') {
                        input_values[type][data][label_tag] = label.val();
                    }
                });
            });

            var isLabelEmpty = false;

            for (var _i4 in input_values.add) {
                var addFields = input_values.add[_i4];

                if (!$scope.isEmpty(addFields)) {
                    for (var a in addFields) {
                        if (a.indexOf('_label') !== -1) {
                            if (addFields[a].length === 0) {
                                isLabelEmpty = true;
                            }
                        }
                    }
                }
            }

            for (var _i5 in input_values.edit) {
                var editFields = input_values.edit[_i5];

                console.log('Edit fields - ', editFields);

                if (!$scope.isEmpty(editFields)) {
                    for (var _a in editFields) {
                        if (_a.indexOf('_label') !== -1) {
                            if (editFields[_a].length === 0) {
                                isLabelEmpty = true;
                            }
                        }
                    }
                }
            }

            if (isLabelEmpty) {
                var options = {
                    title: content['error-label-empty'],
                    type: 'error',
                    delay: 2000
                };

                $scope.show_swal_modal(options).then(function (value) {
                    $scope.$apply(function () {
                        $scope.modal_save_btn = false;
                        $scope.modal_save_continue_btn = false;
                    });
                });
            } else {
                var isEmailValid = true;

                Object.keys(input_values.add).forEach(function (key) {
                    if (input_values.add[key].isValid !== undefined && input_values.add[key].isValid === false) {
                        isEmailValid = false;
                    }
                });

                Object.keys(input_values.edit).forEach(function (key) {
                    if (input_values.edit[key].isValid !== undefined && input_values.edit[key].isValid === false) {
                        isEmailValid = false;
                    }
                });

                if (!isEmailValid) {
                    var options = {
                        title: content['invalid-email'],
                        type: 'error',
                        delay: 2000
                    };

                    $scope.show_swal_modal(options).then(function (value) {
                        $scope.$apply(function () {
                            $scope.modal_save_btn = false;
                            $scope.modal_save_continue_btn = false;
                        });
                    });
                } else {
                    if (!$scope.isEmpty(input_values.add.data1)) {
                        for (var i in input_values.add) {
                            if (input_values.add[i].cpf_checkbox !== undefined) {
                                input_values.add[i].cpf_checkbox = $scope.cpf_checkbox ? 'ON' : 'OFF';
                            }
                        }

                        _this.monitoring.addAssetData(input_values.add).then(function (value) {
                            save_process.count += 1;

                            if (save_process.count == 2) {
                                save_process.count = 0;

                                var options = {
                                    title: content['success-label-saved'],
                                    type: 'success',
                                    delay: 2000
                                };

                                $scope.show_swal_modal(options).then(function (value) {
                                    if (next_id !== false) {
                                        _this.monitoring.getAssetData().then(function (data_value) {
                                            $scope.$apply(function () {
                                                $scope.monitor_add_edit_form = data_value.forms;

                                                $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                                $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                                $scope.id_monitor_add_edit(next_id, 'add');
                                            });
                                        });
                                    } else {
                                        _this.monitoring.getAssetData().then(function (data_value) {
                                            $scope.$apply(function () {
                                                $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                                $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                                $scope.monitor_add_edit_form = data_value.forms;
                                            });
                                        });

                                        modal.modal('toggle');
                                    }
                                });

                                $scope.$apply(function () {
                                    $scope.modal_save_btn = false;
                                    $scope.modal_save_continue_btn = false;
                                });
                            }
                        });
                    } else {
                        save_process.count += 1;
                    }

                    _this.monitoring.updateAssetData(input_values.edit).then(function (value) {
                        $scope.$apply(function () {
                            $scope.modal_save_btn = false;
                        });

                        if (value !== false) {}

                        save_process.count += 1;

                        if (save_process.count == 2) {
                            save_process.count = 0;

                            var options = {
                                title: content['success-label-saved'],
                                type: 'success',
                                delay: 2000
                            };

                            $scope.show_swal_modal(options).then(function (value) {
                                if (next_id !== false) {
                                    _this.monitoring.getAssetData().then(function (data_value) {
                                        $scope.$apply(function () {
                                            $scope.monitor_add_edit_form = data_value.forms;

                                            $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                            $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                            $scope.id_monitor_add_edit(next_id, 'add');
                                        });
                                    });
                                } else {
                                    _this.monitoring.getAssetData().then(function (data_value) {
                                        $scope.$apply(function () {
                                            $scope.monitor_add_edit_form = data_value.forms;

                                            console.log('Is it coming here next id is false');

                                            $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                            $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;
                                        });
                                    });

                                    modal.modal('toggle');
                                }
                            });

                            $scope.$apply(function () {
                                $scope.modal_save_btn = false;
                                $scope.modal_save_continue_btn = false;
                            });
                        }
                    });
                }
            }
        };

        $scope.show_swal_modal = function (options) {
            return new Promise(function (resolve, reject) {
                swal({
                    title: options.title,
                    type: options.type,
                    showConfirmButton: false,
                    timer: options.delay
                }).then(function (result) {
                    resolve(true);
                });
            });
        };

        $scope.isEmpty = function (obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    return false;
                }
            }

            return true;
        };

        $scope.isChanged = function (arr) {};

        $scope.monitor_skip = function (index, type) {
            if (_this.monitoring.add_edit_forms(index) === undefined) {
                index = 0;
            }

            $scope.id_monitor_add_edit(index, type);
        };

        $scope.id_monitor_add_edit = function (index, type) {
            var modal = $('#modal-monitor-add-edit'),
                form = _this.monitoring.add_edit_forms(index),

            //name_title 	= (type == 'add') ? `${content['data-monitoring-page-prefix-add']} ${form.name}` : `${content['data-monitoring-page-prefix-edit']} ${form.name}`,
            name_title = form.name,
                fields = $scope.monitor_add_edit_form[index].fields;

            $scope.modal_monitor_form = {
                id: index,
                title: name_title,
                details: form,
                html: $sce.trustAsHtml(_this.monitoring[form.alias](fields))
            };

            modal.modal();

            $timeout(function () {
                if (jQuery().datepicker) {
                    $('.date-picker').datepicker({
                        autoclose: true
                    });
                }
            }, 100);

            //$('.date-picker').datepicker();
        };

        $scope.modal_close = function () {
            var modal = $('#modal-monitor-add-edit');

            modal.modal('toggle');
        };

        $scope.send_request_form = function ($event) {
            var form = $($event.target).parents('#modal-monitor-request-assistance').find('form'),
                option = $('.requestAssistanceForm option:selected'),
                value = option.attr('value'),
                modal = $('#modal-monitor-request-assistance'),
                post = {};

            post.request_type = value;

            form.find('input').each(function () {
                var name = $(this).attr('name'),
                    value = $(this).val();

                post[name] = value;
            });

            post.comments = form.find('textarea').val();

            $scope.submit_request_button = true;

            _this.resCenter.requestCallPost(post).then(function (value) {
                $timeout(function () {
                    $scope.submit_request_button = false;
                }, 100);

                if (value.success) {
                    swal({
                        title: content['request-assistance-swal-title'],
                        text: content['request-assistance-swal-text'],
                        type: 'success'
                    }).then(function (value) {
                        modal.modal('toggle');
                    });
                }
            });
        };

        $('#request_assistance').on("change", function (e) {
            var option = $('#request_assistance option:selected'),
                key = option.attr('key'),
                value = option.attr('value'),
                modal = $('#modal-monitor-request-assistance');

            $scope.$apply(function () {
                $scope.request_assistance_selected_key = key;
            });

            modal.modal('toggle');
        });

        $('#res_center_initial').on("change", function (e) {
            var option = $("#res_center_initial option:selected"),

            //option_selected	= $scope.resolution_center.initial_list[option.attr('key')],
            article_id = option.attr('article_id');

            resCenter.getArticle(article_id).then(function (value) {
                $scope.$apply(function () {
                    $scope.article = $sce.trustAsHtml(value.article);
                });

                resCenter.getGroupById(value.resolution_group_id).then(function (group_value) {
                    $scope.$apply(function () {
                        $scope.resolution_group = group_value;
                    });
                });
            });
        });

        $('#res_center_second').on("change", function (e) {
            var option = $("#res_center_initial option:selected"),
                option_selected = $scope.resolution_center.second_list.list[option.attr('key')];

            $scope.resolution_center.second_list.second_alias = option_selected.alias;

            resCenter.getArticle(option_selected.article_id).then(function (value) {
                $scope.$apply(function () {
                    $scope.article = $sce.trustAsHtml(value.article);
                });

                resCenter.getGroupById(value.resolution_group_id).then(function (group_value) {
                    $scope.$apply(function () {
                        $scope.resolution_group = group_value;
                    });
                });
            });
        });

        $('#res_center_resolution').on("change", function (e) {
            var option = $("#res_center_resolution option:selected");

            resCenter.getArticle(option.val()).then(function (value) {
                $scope.$apply(function () {
                    $scope.resolution_center.resolution = $sce.trustAsHtml(value.article);
                });
            });
        });

        $scope.menuClickedItem = function ($event) {
            var link = $($event.target).parents('li').find('a').attr('href');

            $window.location.href = link;
        };

        $scope.gotoResCenter = function () {
            var second_list = $scope.resolution_center.second_list;

            $window.location.href = '/user/resolution-center/' + second_list.initial_alias + '/' + second_list.second_alias;
        };

        $scope.downloadSoftware = function () {
            $window.location.href = '/user/download-odp';
        };

        $scope.scroll_to = function (anchor) {
            var section = $('#' + anchor),
                position = section.offset().top;

            $('html, body').animate({
                scrollTop: position - $scope.mtStepColHeight
            }, 200);
        };

        $scope.getMonitoringDetails = function () {
            return new Promise(function (resolve, reject) {
                _this.monitoring.getAssetData().then(function (value) {
                    var forms = value.forms;

                    _this.monitoring.forms.forEach(function (forms) {
                        if (value.alias === 'cpf_number') {
                            if (parseInt(forms.fields.length) > 0) {
                                $scope.$apply(function () {
                                    $scope.cpf_checkbox = true;
                                });
                            }
                        }
                    });

                    resolve(value.forms);
                });
            });
        };

        $scope.getIdentityRiskDetails = function (ladda_desc, obj, block, initial_load) {
            return new Promise(function (resolve, reject) {
                _this.monitoring.getIdentityRiskDetails().then(function (value) {
                    $scope.personal_dial = _this.dials.small_dial(value.scores.personal, value.scores.personalRisk, smallDialTrackColor);
                    $scope.finance_dial = _this.dials.small_dial(value.scores.financial, value.scores.financialRisk, smallDialTrackColor);
                    $scope.dark_web_dial = _this.dials.small_dial(value.scores.darkweb, value.scores.darkwebRisk, smallDialTrackColor);
                    $scope.risk_level_dial = _this.dials.risk_level_dial(value.scores.overall, value.scores.overallRisk);

                    $scope.$apply(function () {
                        $scope[ladda_desc] = false;

                        if (block !== false) {
                            if (obj.css('display') == 'none') {
                                block.find('.icon-arrow-down').css({
                                    'bottom': css_arrow_pos,
                                    'visibility': 'visible'
                                });
                            }
                        }

                        if (initial_load !== true) {
                            obj.animate({
                                display: 'block',
                                height: "toggle"
                            }, 100);
                        } else {
                            $('.col-md-2:nth-child(1)').find('.icon-arrow-down').css({
                                'bottom': css_arrow_pos,
                                'visibility': 'visible'
                            });
                        }

                        $scope.monitor_table = value.hits;

                        var alerts = 0;

                        value.hits.forEach(function (hit) {
                            if (hit.help_opened == 0) {
                                alerts += 1;
                            }
                        });

                        $scope.notification = alerts;

                        var columns = [{ data: "hit_id" }, { data: "online_address" }, { data: "help" }, { data: "where" }, { data: "found" }, { data: "match" }, { data: "date" }, { data: "risk" }],
                            columnDefs = [];

                        if ($scope.ignore_feature) {
                            columns.push({ data: "actions" });
                        }

                        columns.push({ data: "help_opened" });

                        for (var i in columns) {
                            switch (columns[i].data) {
                                case 'help_opened':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        searchable: false,
                                        orderable: false,
                                        visible: false,
                                        render: function render(data, type, row, meta) {
                                            return data;
                                        }
                                    });
                                    break;

                                case 'hit_id':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        searchable: true,
                                        orderable: false,
                                        visible: true,
                                        render: function render(data, type, row, meta) {
                                            return data;
                                        }
                                    });
                                    break;

                                case 'online_address':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        render: function render(data, type, row, meta) {
                                            if (data !== null && data !== undefined) {
                                                if (window.innerWidth < 500) {
                                                    return data.substring(0, 25) + '...';
                                                }
                                            }

                                            var data_link = data;

                                            if (row.where == 'publicweb') {
                                                data_link = '<a href="' + data + '" target="_blank" style="text-decoration: underline;">' + data + '</a>';
                                            }

                                            return data_link;
                                        }
                                    });
                                    break;

                                case 'help':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: false,
                                        orderable: false,
                                        render: function render(data, type, row, meta) {
                                            var where = row.where !== 'publicweb' ? 'darkweb' : 'publicweb';

                                            return '<svg width="50" style="left: 50%; transform: translate(-50%, -50%);" assist-row-id="' + meta.row + '" assist-where="' + where + '" assist-found="' + row.found + '" class="assist-info"><use xlink:href="#info-2" /></svg>';
                                        }
                                    });
                                    break;

                                case 'where':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        render: function render(data, type, row, meta) {
                                            var $data = 'Public Web';

                                            if (data !== 'publicweb') {
                                                $data = content['identity-page-dark-web-text'];
                                            }

                                            return $data;
                                        }
                                    });
                                    break;

                                case 'found':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        render: function render(data, type, row, meta) {
                                            var $data = data;

                                            switch (data) {
                                                case 'email':
                                                    $data = content['data-monitoring-page-circle-name-email'];
                                                    break;
                                                case 'credit_card':
                                                    $data = content['data-monitoring-page-circle-name-credit-card'];
                                                    break;
                                                case 'address':
                                                    $data = content['data-monitoring-page-circle-name-address'];
                                                    break;
                                                case 'dob':
                                                    $data = content['data-entry-form-dob'];
                                                    break;
                                                case 'phone':
                                                    $data = content['data-monitoring-page-circle-name-landline'];
                                                    break;
                                                case 'bank_account bank_code':
                                                    $data = content['data-monitoring-page-circle-name-bank'];
                                                    break;
                                                case 'mobile':
                                                    $data = content['data-monitoring-page-circle-name-mobile'];
                                                    break;
                                                case 'driving_license':
                                                    $data = content['data-monitoring-page-circle-name-driver-license'];
                                                    break;
                                                case 'passport':
                                                    $data = content['data-monitoring-page-circle-name-passport'];
                                                    break;
                                                case 'id_card':
                                                    $data = content['data-monitoring-page-circle-name-ni'];
                                                    break;
                                                case 'ebay':
                                                    $data = content['data-monitoring-page-circle-name-ebay'];
                                                    break;
                                                case 'paypal':
                                                    $data = content['data-monitoring-page-circle-name-paypal'];
                                                    break;
                                                case 'iban bic':
                                                    //$data = content['data-monitoring-page-circle-name-email'];
                                                    break;
                                            }

                                            return $data;
                                        }
                                    });
                                    break;

                                case 'date':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        type: 'date', // as seen on https://datatables.net/reference/option/columns.type
                                        render: function render(data, type, row, meta) {
                                            var d = new Date(data),
                                                month = '' + (d.getMonth() + 1),
                                                day = '' + d.getDate(),
                                                year = d.getFullYear();

                                            if (month.length < 2) month = '0' + month;
                                            if (day.length < 2) day = '0' + day;

                                            return year + '-' + month + '-' + day;
                                        }
                                    });
                                    break;

                                case 'risk':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        render: function render(data, type, row, meta) {
                                            return content['risk-level-dial-txt-' + data].toUpperCase();
                                        }
                                    });
                                    break;

                                case 'actions':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        sortable: false,
                                        searchable: false,
                                        render: function render(data, type, row, meta) {
                                            return '<div class="text-center">\n                                                        <button\n                                                            data-id="' + row.hit_id + '"\n                                                            data-type="_ignore"\n                                                            data-toggle="tooltip"\n                                                            data-placement="top" \n                                                            class="btn btn-danger btn-sm"\n                                                            title="' + content['identity-fraud-page-ignore-action'] + '"\n                                                         >\n                                                            <i class="fa fa-eye-slash"></i>\n                                                        </button>\n                                                    </div>';
                                        }
                                    });
                                    break;
                            }
                        }

                        table = $('#datatable-results').DataTable({
                            data: value.hits,
                            columns: columns,
                            columnDefs: columnDefs,
                            responsive: true,
                            destroy: true,
                            order: [[0, "desc"]],
                            language: {
                                search: content['identity-fraud-page-table-search'],
                                info: content['identity-fraud-page-table-show'] + content['identity-fraud-page-table-show-start-end-total'],
                                lengthMenu: content['identity-fraud-page-table-show'] + " _MENU_ " + content['identity-fraud-page-table-entries'],
                                infoEmpty: content['identity-fraud-page-table-show'] + ' ' + content['identity-fraud-page-table-show-start-end-total-0'] + ' ' + content['identity-fraud-page-table-entries'] + '  ',
                                emptyTable: content['identity-fraud-page-table-empty'],
                                infoFiltered: content['identity-fraud-page-table-filtered'] ? content['identity-fraud-page-table-filtered'] : "(filtered from _MAX_ total entries)",
                                paginate: {
                                    next: content['identity-fraud-page-table-next'],
                                    previous: content['identity-fraud-page-table-previous']
                                }
                            },
                            createdRow: function createdRow(row, data, index) {
                                var risk_row = $('td', row).eq(7);

                                risk_row.addClass('text-center');
                                risk_row.addClass('font-white');
                                risk_row.addClass('danger-' + data.risk);

                                if (data.help_opened == 0) {
                                    $('td', row).css('font-weight', 'bold');
                                }
                            }
                        });

                        $.fn.dataTable.ext.errMode = 'none';

                        resolve(value);
                    });
                });
            });
        };
    }

    _createClass(PortalController, [{
        key: 'createMonitoringDial',
        value: function createMonitoringDial(assetPercent, assetCount) {
            var trackColor = '#9B9B9B',
                trackWidth = 1,
                arcBorder = false,
                arcColor = '#FFFFFF',
                smallDialTrackColor = '#ECECEC';

            if (window.brand_code == 'ea_gma_ch') {
                trackColor = dial_colors[0];
                trackWidth = 3;
                arcBorder = true;
                arcColor = '#7f9fa9';
                smallDialTrackColor = arcColor;
            }

            return this.dials.monitoring_dial(assetPercent, assetCount, window.monitor_bar_color, trackColor, trackWidth, arcBorder, arcColor);
        }
    }]);

    return PortalController;
}();

exports.default = PortalController;

},{"../models/Assistance":4,"../models/Dials":5,"../models/Download":6,"../models/Monitoring":8,"../models/ResolutionCenter":9,"../models/User":10}],3:[function(require,module,exports){
'use strict';

var _LoginController = require('../controllers/LoginController');

var _LoginController2 = _interopRequireDefault(_LoginController);

var _PortalController = require('../controllers/PortalController');

var _PortalController2 = _interopRequireDefault(_PortalController);

var _FormatHTML = require('../services/FormatHTML');

var _FormatHTML2 = _interopRequireDefault(_FormatHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import CompileDirectory from '../services/CompileDirective';
//import CamelCase from '../services/CamelCase';
//import TrustAsHtml from '../services/TrustAsHtml';

angular.module('dmsGenerali', ['ngRoute', 'ngAnimate', 'ui.knob', 'ngValidate', 'angular-ladda', 'ngStorage']).controller('LoginController', _LoginController2.default).controller('PortalController', _PortalController2.default).directive('compile', function ($compile, $timeout) {
	return {
		restrict: 'A',
		link: function link(scope, elem, attrs) {
			$compile(elem.contents())(scope);
		}
	};
}).directive('aliasKeyPress', function () {
	return function (scope, element, attrs) {
		element.bind("keydown keypress keyup", function (event) {
			var value = attrs.$$element[0].value;

			scope.$apply(function () {
				//scope.$eval(attrs.aliasKeyPress);

				//console.log(event.which);
				//console.log(event.key);
			});

			scope[attrs.aliasKeyPress](value, event.key, attrs.$$element[0]).then(function (v) {
				if (v.success === false) {
					attrs.$$element[0].value = v.value.substring(0, v.value.length - 1);
				} else {
					if (v.value !== undefined) {
						attrs.$$element[0].value = v.value;
					}
				}

				if (v === false) {
					event.preventDefault();
				}
			});
		});
	};
}).directive('bindHtmlCompile', ['$compile', function ($compile) {
	return {
		restrict: 'A',
		link: function link(scope, element, attrs) {
			scope.$watch(function () {
				return scope.$eval(attrs.bindHtmlCompile);
			}, function (value) {
				// In case value is a TrustedValueHolderType, sometimes it
				// needs to be explicitly called into a string in order to
				// get the HTML string.
				element.html(value && value.toString());
				// If scope is provided use it, otherwise use parent scope
				var compileScope = scope;
				if (attrs.bindHtmlScope) {
					compileScope = scope.$eval(attrs.bindHtmlScope);
				}
				$compile(element.contents())(compileScope);
			});
		}
	};
}]).directive('inputHealthChecker', function ($compile) {
	return function (scope, element, attr) {
		element.bind("keypress keyup blur", function (event) {
			var hidden_fields = $('div.health-checker input[type=hidden]'),
			    passwd_val = $(this).val();

			//Policies array would be initiated from outside of this controller within the DOM
			policies = [];

			hidden_fields.each(function () {
				var policy = JSON.parse($(this).val());

				policy.status = 0;
				policies.push(policy);
			});

			policies.forEach(function (value) {
				var list_name = $('ul li.' + value.name);

				value.status = 0;

				if (value.type === 'length') {
					if (passwd_val.length >= value.value) {
						value.status = 1;
					}
				}

				if (value.type === 'regex') {
					var string = value.value,
					    match = passwd_val.match(string);

					if (match) {
						value.status = 1;
					}
				}

				if (value.status === 1) {
					list_name.addClass('accepted');
					list_name.find('span').html('<svg><use xlink:href="#accept" /></svg>');
				} else {
					list_name.removeClass('accepted');
					list_name.find('span').html('<svg><use xlink:href="#cancel" /></svg>');
				}
			});
		});
	};
}).filter('camelCase', function () {
	return function (input) {
		if (input === undefined) {
			return;
		}

		var str_lower = input.toLowerCase(),
		    str_split = str_lower.split(" ");

		for (var i in str_split) {
			var str = str_split[i];

			str_split[i] = str.substring(0, 1).toUpperCase() + str.substring(1);
		}

		return str_split.join(" ");
	};
}).filter('trustAsHtml', ['$sce', function ($sce) {
	return function (input) {
		return $sce.trustAsHtml(input);
	};
}]).filter('formatHtml', ['$sce', function ($sce) {
	return function (input) {
		var content = new _FormatHTML2.default();

		return content.showString(input);
	};
}]).config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
	$locationProvider.html5Mode({
		enabled: true,
		requireBase: true
	});
}]); /*
       Import all Angular components via ES6 imports and register them
     */

},{"../controllers/LoginController":1,"../controllers/PortalController":2,"../services/FormatHTML":12}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class Assistance
 */
var Assistance = function () {
    function Assistance(content, scan_policy) {
        _classCallCheck(this, Assistance);

        this.scan_policy = scan_policy;
        this.content = {
            darkweb: {},
            publicweb: {}
        };

        for (var i in content) {
            var index = Object.keys(this.content)[i];

            if (index !== undefined) {
                this.content[index].title = content[i].title;

                this.content[index].groups = { personal: {}, financial: {}, other: {} };

                if (content[i].groups[0] !== undefined) {
                    this.content[index].groups.personal = {
                        title: content[i].groups[0].title,
                        text: content[i].groups[0].text
                    };
                }

                if (content[i].groups[1] !== undefined) {
                    this.content[index].groups.financial = {
                        title: content[i].groups[1].title,
                        text: content[i].groups[1].text
                    };
                }

                if (content[i].groups[2] !== undefined) {
                    this.content[index].groups.other = {
                        title: content[i].groups[2].title,
                        text: content[i].groups[2].text
                    };
                }
            }
        }
    }

    //Finds text for personal or financial asisstance data


    _createClass(Assistance, [{
        key: 'create',
        value: function create(where, match) {
            var personal_or_financial = '';

            for (var i in this.scan_policy) {
                if (match == this.scan_policy[i].target_dbfield) {
                    personal_or_financial = parseInt(this.scan_policy[i].financial) === 1 ? 'financial' : 'personal';

                    if (!parseInt(this.scan_policy[i].financial) && this.scan_policy[i].target_dbfield !== 'email') {
                        personal_or_financial = 'other';
                    }
                }
            }

            return this.content[where].groups[personal_or_financial];
        }
    }]);

    return Assistance;
}();

exports.default = Assistance;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class Dials
 */
var Dials = function () {
	function Dials(size_large, size_small, content, colors) {
		_classCallCheck(this, Dials);

		this.size_large = size_large;
		this.size_small = size_small;
		this.risk_colors = colors;

		this.content = content;
	}

	_createClass(Dials, [{
		key: 'set_dial_properties',
		value: function set_dial_properties(risk) {
			var color = this.risk_colors[0],
			    text = this.content['risk-level-dial-txt-low'],
			    index = 0;

			switch (risk) {
				case 'medium':
					color = this.risk_colors[1];
					text = this.content['risk-level-dial-txt-medium'];
					index = 1;
					break;

				case 'high':
					color = this.risk_colors[2];
					text = this.content['risk-level-dial-txt-high'];
					index = 2;
					break;
			}

			return {
				color: color,
				text: text.toUpperCase(),
				index: index
			};
		}
	}, {
		key: 'simple_dial_options',
		value: function simple_dial_options(value, risk, trackColor) {
			var trackWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
			var arcBorder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
			var arcColor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '#FFFFFF';

			var properties = this.set_dial_properties(risk);

			return {
				startAngle: -120,
				endAngle: 120,
				displayPrevious: false,
				trackColor: trackColor,
				barColor: properties.color,
				readOnly: true,
				trackWidth: trackWidth,
				barWidth: 10,
				middleArc: {
					show: false,
					border: arcBorder,
					color: arcColor
				},
				arcOpacity: 0,
				size: this.size_small,
				displayNumber: {
					enabled: false
				},
				textMiddle: {
					enabled: true,
					text: properties.text,
					color: properties.color
				},
				subText: {
					enabled: false
				},
				topBottomText: {
					enabled: false
				},
				scale: {
					enabled: false
				},
				dynamicOptions: true
			};
		}
	}, {
		key: 'risk_level_dial',
		value: function risk_level_dial(value, risk) {
			var trackColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#9B9B9B';
			var trackWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
			var arcBorder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
			var arcColor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '#FFFFFF';

			var properties = this.set_dial_properties(risk),
			    colors = ['#FFFFFF', '#FFFFFF', '#FFFFFF'];

			for (var i = 0; i <= properties.index; i++) {
				colors[i] = this.risk_colors[i];
			}

			var options = {
				startAngle: 180,
				endAngle: 360,
				displayPrevious: false,
				trackColor: trackColor,
				barColor: properties.color,
				readOnly: true,
				trackWidth: trackWidth,
				barWidth: 10,
				size: this.size_large,
				middleArc: {
					show: true,
					border: arcBorder,
					color: arcColor
				},
				arcOpacity: 1,
				displayType: 'monitor',
				displayDanger: {
					text: properties.text,
					colors: colors
				},
				displayNumber: {
					enabled: false
				},
				subText: {
					enabled: true,
					text: this.content['risk-level-dial-txt-risk-level']
				},
				topBottomText: {
					enabled: true,
					topTxt: this.content['risk-level-dial-txt-high'].toUpperCase(),
					bottomTxt: this.content['risk-level-dial-txt-low'].toUpperCase()
				},
				scale: {
					enabled: true,
					type: 'lines',
					width: 1,
					quantity: 3
				}
			};

			return {
				value: value,
				options: options
			};
		}
	}, {
		key: 'monitoring_dial',
		value: function monitoring_dial(value, assetCount, barColor) {
			var trackColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#9B9B9B';
			var trackWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
			var arcBorder = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
			var arcColor = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '#FFFFFF';

			var options = {
				startAngle: 180,
				endAngle: 0.1,
				displayPrevious: false,
				trackColor: trackColor,
				barColor: barColor,
				readOnly: true,
				trackWidth: trackWidth,
				barWidth: 10,
				size: this.size_large,
				middleArc: {
					show: true,
					border: arcBorder,
					color: arcColor
				},
				displayType: 'count',
				displayTxtItems: this.content['monitoring-dial-txt-items'].toUpperCase(),
				arcOpacity: 1,
				displayNumber: {
					enabled: true,
					number: assetCount
				},
				subText: {
					enabled: true,
					text: this.content['monitoring-dial-txt-monitoring']
				},
				topBottomText: {
					enabled: true,
					topTxt: this.content['monitoring-dial-txt-strong'].toUpperCase(),
					bottomTxt: this.content['monitoring-dial-txt-weak'].toUpperCase()
				},
				scale: {
					enabled: true,
					type: 'lines',
					width: 1,
					quantity: 3
				}
			};

			return {
				value: value,
				options: options
			};
		}
	}, {
		key: 'small_dial',
		value: function small_dial(value, risk) {
			var trackColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#ECECEC';

			return {
				value: value,
				options: this.simple_dial_options(value, risk, trackColor)
			};
		}
	}]);

	return Dials;
}();

exports.default = Dials;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Software2 = require('./abstract/Software');

var _Software3 = _interopRequireDefault(_Software2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Model class Download
 */
var Download = function (_Software) {
	_inherits(Download, _Software);

	function Download($sce, $content) {
		var $deviceDisplayCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

		_classCallCheck(this, Download);

		var _this = _possibleConstructorReturn(this, (Download.__proto__ || Object.getPrototypeOf(Download)).call(this, $sce, $content, $deviceDisplayCount));

		_this.$sce = $sce;
		_this.content = $content;
		_this.mobileProtected = $sce.trustAsHtml('<svg><use xlink:href="#mobile-protected" class="screen" /></svg>');
		_this.mobileUnProtected = $sce.trustAsHtml('<svg><use xlink:href="#mobile-unprotected" class="screen" /></svg>');
		return _this;
	}

	_createClass(Download, [{
		key: 'getInstallCount',
		value: function getInstallCount(device) {
			return new Promise(function (resolve, reject) {
				$.get('/user/get-odp-install-count/' + device, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getInstallCountForPcAndMac',
		value: function getInstallCountForPcAndMac(devices) {
			return new Promise(function (resolve, reject) {
				var installedCounts = { dpsCount: 0 };

				$.get('/user/get-odp-install-count/' + devices[0], function (data) {
					installedCounts.dpsCount += data.dpsCount;

					if (devices.length > 1) {
						$.get('/user/get-odp-install-count/' + devices[1], function (data) {
							installedCounts.dpsCount += data.dpsCount;

							resolve(installedCounts);
						});
					} else {
						resolve(installedCounts);
					}
				});
			});
		}
	}, {
		key: 'getDownloadData',
		value: function getDownloadData(device) {
			var text = "";

			switch (device) {
				case 'pc':
					text = '<h4>About Data Protection Suite</h4>\n\t\t\t\t\t\t<p>The PC and Laptop Secure Browser you can browse the internet securely and protect yoursel from the threats associated with keylogging,\n\t\t\t\t\t\tscreen capture and phishing every time you enter data online</p>\n\t\t\t\t\t\t<p>For more information on how the Onlien Protection Software works please goto the FAQs section.</p>';
					break;

				case 'mobile':
					text = '<h4>Mobile Security Suite</h4\n\t\t\t\t\t\t<p>Google powered secure browser protects you from any threat to the data you input on the web and will warn you away from fraudulent\n\t\t\t\t\t\twebsites trying to steal your personal information.</p>\n\t\t\t\t\t\t<p>To download and register the Smartphone Protection SOftware to your device, follow these steps\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li>If you are on your mobile or tablet device:<p>Click ont he relevent App Store logo for youe device at the bottom to go directly to the App page</p></li>\n\t\t\t\t\t\t\t\t<li>Download the App. Once installed, open the appplication on your device and complete the registration process. You will need your membership\n\t\t\t\t\t\t\t\tnumber (which you can find in your account profile from the dashboard when you are logged into the website) and your date of birth.</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</p>';
					break;
			}

			return text;
		}
	}]);

	return Download;
}(_Software3.default);

exports.default = Download;

},{"./abstract/Software":11}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class Form
 */
var MonitorForms = function () {
	function MonitorForms($http, $customer, $content, $mobile, $home_address_order, $member_id) {
		_classCallCheck(this, MonitorForms);

		this.member_id = $member_id;
		this.http = $http;
		this.customer = $customer;
		this.content = $content;
		this.home_address_order = $home_address_order;
		this.data_content = this.content['form-label-msg'];
		this.popover_script = "<script>$('[data-toggle=\"popover\"]').popover({ trigger: \"hover\", container: '.monitorFormIsAbout' });</script>";
		this.preset = $mobile == true ? '/#/data-monitoring/' : '/user/dashboard/';
	}

	_createClass(MonitorForms, [{
		key: 'home_address_ordered',
		value: function home_address_ordered() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

			var addr1 = '',
			    addr2 = '',
			    addr3 = '',
			    postcode = '',
			    city = '';

			if (fields !== undefined) {
				addr1 = fields.addr1;
				addr2 = fields.addr2;
				addr3 = fields.addr3;
				postcode = fields.postcode;
				city = fields.city;
			}

			var address_fields = {
				'addr1': '<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-address-house'] + '</label>\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric" label="true" name="addr1" placeholder="" value="' + addr1 + '" />\n\t\t\t\t\t\t\t\t</div>',
				'addr2': '<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-street-name'] + '</label>\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="addr2" placeholder="" value="' + addr2 + '" />\n\t\t\t\t\t\t\t\t</div>',
				'addr3': '<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-additional'] + '</label>\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="addr3" placeholder="" value="' + addr3 + '" />\n\t\t\t\t\t\t\t\t</div>',
				'postcode': '<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-postcode'] + '</label>\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="postcode" label="true" placeholder="" value="' + postcode + '" />\n\t\t\t\t\t\t\t\t</div>',
				'city': '<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-city'] + '</label>\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="city" label="true" placeholder="" value="' + city + '" />\n\t\t\t\t\t\t\t\t</div>'
			};

			var address_order_result = {};

			for (var i in this.home_address_order) {
				address_order_result[this.home_address_order[i]] = address_fields[this.home_address_order[i]];
			}

			return address_order_result;
		}
	}, {
		key: 'personal_details',
		value: function personal_details() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var details = {
				first_name: "",
				last_name: "",
				alias: "",
				dob: "",
				sd_id: undefined,
				p_id: undefined
			},
			    addEdit = 'add';

			for (var i in fields) {
				for (var key in fields[i]) {
					if (key == 'first_name' || key == 'last_name' || key == 'alias' || key == 'dob' || key == 'sd_id' || key == 'p_id') {
						details[key] = fields[i][key];
					}
				}
			}

			if (details.sd_id !== undefined) {
				addEdit = 'edit';
			}

			return '<div class="group ' + addEdit + '">\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<label>' + this.content['data-entry-form-first-name'] + '</label>\n                        <input type="text" class="form-control" model="first_name" name="first_name" value="' + this.customer.first_name + '" readonly>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<label>' + this.content['data-entry-form-last-name'] + '</label>\n\t\t\t\t\t\t<input type="text" class="form-control" model="last_name" name="last_name" value="' + this.customer.last_name + '" readonly>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<label>' + this.content['data-entry-form-alias'] + '</label>\n\t\t\t\t\t\t<input type="text" class="form-control" model="alias" name="alias" value="' + this.customer.alias + '" readonly>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group ' + (details.sd_id !== undefined ? 'col-md-5' : 'col-md-6') + '">\n\t\t\t\t\t\t<label>' + this.content['data-entry-form-dob'] + '</label>\n\t\t\t\t\t\t<input type="hidden" name="_label" value="' + this.content['data-entry-form-dob'] + '" />\n\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric" model="dob" label="true"  name="dob" alias-key-press="aliasKeyPressEvent" placeholder="' + this.content['placeholder-dob-format'] + '" value="' + details.dob + '" />\n\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + details.sd_id + '" />\n\t\t\t\t\t\t<i data-toggle="popover" data-content="Date of Birth entered is incorrect" data-placement="left" class="fa fa-exclamation-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t<i class="fa fa-check-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t<script>$(\'[data-toggle="popover"]\').popover({ trigger: "hover" });</script>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<svg data-ng-if="' + (details.sd_id !== undefined) + '" data-ng-click="delete_monitor_info(' + details.sd_id + ', ' + details.p_id + ', \'dob\', $event, modal_monitor_form.id)" class="flag-icon dob-delete"><use xlink:href="#delete-2" /></svg>\n\t\t\t\t\t</div>\n\t\t\t</div>';
		}
	}, {
		key: 'credit_cards',
		value: function credit_cards() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-credit'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', [' + fields[i].p_id + '], \'cc\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#credit_card-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="credit_card-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-credit-card'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric" label="true" name="credit_card" value="' + fields[i].credit_card + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-credit-card'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric" label="true" name="credit_card">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'drivers_licenses',
		value: function drivers_licenses() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-driver'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'driving_license\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#license-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="license-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-driver-license'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="driving_license" placeholder="" value="' + fields[i].driving_license + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-driver-license'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="driving_license" placeholder="">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'home_address',
		value: function home_address() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-address'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'address\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#license-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div id="license-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>';

				var editAddress = this.home_address_ordered(fields[i]);

				for (var _i in editAddress) {
					group += editAddress[_i];
				}

				group += '<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t  <input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			var add = '<div class="group add">\n\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>';

			var addNewAddress = this.home_address_ordered();

			for (var _i2 in addNewAddress) {
				add += addNewAddress[_i2];
			}

			add += '</div>\n\t\t\t\t</div>' + group;

			return add;
		}
	}, {
		key: 'bank_accounts',
		value: function bank_accounts() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-bank'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'bank\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#license-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="license-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-bank-account'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="bank_account" placeholder="" value="' + fields[i].bank_account + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group bank_code col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-bank-sort-code'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="bank_code" placeholder="" value="' + fields[i].bank_code + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-bank-account'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="bank_account" placeholder="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group bank_code col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-bank-sort-code'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="bank_code" placeholder="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'cpf_number',
		value: function cpf_number() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var sd_id = '',
			    p_id = '';

			for (var i in fields) {
				sd_id = fields[i].sd_id;
				p_id = fields[i].p_id;
			}

			return '<div class="group add">\n\t\t\t\t\t<input type="hidden" name="sd_id" value="' + sd_id + '" />\n\t\t\t\t\t<input type="hidden" name="p_id" value="' + p_id + '" />\n\t\t\t\t\t<input type="hidden" name="_label" value="CPF Number" />\n\t\t\t\t\t<input type="hidden" name="passport" value="' + this.member_id + '" />\n\t\t\t\t\t<input type="hidden" name="cpf_checkbox" data-ng-value="cpf_checkbox == true ? \'ON\' : \'OFF\'" />\n\t\t\t\t\t\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="form-group col-md-6 cpf">\n\t\t\t\t\t\t\t<label>' + this.member_id + '</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class="form-group col-md-3 pull-right">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<label data-ng-bind="cpf_checkbox ? \'' + this.content['data-monitoring-page-cpf-number-activated'] + '\' : \'' + this.content['data-monitoring-page-cpf-number-deactivated'] + '\'"></label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>';
		}
	}, {
		key: 'passport',
		value: function passport() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-passport'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'passport\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#passport-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="passport-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-passport-number'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="passport" placeholder="" value="' + fields[i].passport + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-passport-number'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="passport" placeholder="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'email_address',
		value: function email_address() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-email'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', [' + fields[i].p_id + '], \'email\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#e-mail-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="e-mail-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-email-address'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="email" value="' + fields[i].email + '">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-email-address'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="email" placeholder="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'phone_number',
		value: function phone_number() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-landline'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'phone\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#phone-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="phone-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-landline'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="phone" value="' + fields[i].phone + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" />\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-landline'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="phone" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'mobile_number',
		value: function mobile_number() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-mobile'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'mobile\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#mobile-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="mobile-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-mobile-number'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="mobile" value="' + fields[i].mobile + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" />\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-mobile-number'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" data-input-type="numeric_phone" label="true" name="mobile" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'national_insurance_number',
		value: function national_insurance_number() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-ni'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'ssn\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#ni-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="ni-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-ssn'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="ssn" value="' + fields[i].ssn + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-ssn'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="ssn" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'social_network',
		value: function social_network() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-social-network'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'social_network\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#social_network-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="social_network-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<input type="hidden" name="no-monitoring" value="social_network">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-social-network-name'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-social-network-login'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="social_network" placeholder="" value="' + fields[i].email + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<input type="hidden" name="no-monitoring" value="social_network">\n\t\t\t\t\t<div class="col-md-12"">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-social-network-name'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-social-network-login'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="social_network" placeholder="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'ebay',
		value: function ebay() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-driver'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'ebay\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#license-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="license-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-ebay'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="ebay" placeholder="" value="' + fields[i].ebay + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-ebay'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="ebay" placeholder="">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'paypal',
		value: function paypal() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			var group = "";

			if (fields.length > 0) {
				group = '<div class="col-md-12"><h4 class="modal-title"><span class="faq-icon fa fa-pencil-square-o"></span> ' + this.content['data-monitoring-page-prefix-edit-driver'] + '</h4></div>';
			}

			for (var i in fields) {
				group += '<div class="col-md-12 block">\n\t\t\t\t\t\t<div id="accordion-' + i + '" role="tablist" aria-multiselectable="true">\n\t\t\t\t\t\t\t<div class="card wow fadeInUp">\n\t\t\t\t\t\t\t\t<svg data-ng-click="delete_monitor_info(' + fields[i].sd_id + ', ' + fields[i].p_id + ', \'paypal\', $event, modal_monitor_form.id)" class="flag-icon"><use xlink:href="#delete-2" /></svg>\n\n\t\t\t\t\t\t\t\t<a data-toggle="collapse" data-parent="#accordion-' + i + '" class="collapsed" href="' + this.preset + '#license-' + i + '">\n\t\t\t\t\t\t\t\t\t' + fields[i].label + '\n\t\t\t\t\t\t\t\t\t<span class="faq-arrow flaticon-down-arrow-1"></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div id="license-' + i + '" class="collapse" role="tabpanel">\n\t\t\t\t\t\t\t\t<div class="group edit">\n\t\t\t\t\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" value="' + fields[i].label + '">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-paypal'] + '</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="paypal" placeholder="" value="' + fields[i].paypal + '" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="sd_id" value="' + fields[i].sd_id + '" />\n\t\t\t\t\t\t\t\t\t\t<input type="hidden" name="p_id" value="' + fields[i].p_id + '" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
			}

			return '<div class="group add">\n\t\t\t\t\t<div class="col-md-12">\n\t\t\t\t\t\t<div class="col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-label'] + '</label>\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t<i data-toggle="popover" data-content="' + this.data_content + '" data-placement="left" class="fa fa-question-circle" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="_label" placeholder="">\n\t\t\t\t\t\t\t\t' + this.popover_script + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<label>' + this.content['data-entry-form-paypal'] + '</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" label="true" name="paypal" placeholder="">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>' + group;
		}
	}, {
		key: 'id_number',
		value: function id_number() {
			var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		}
	}]);

	return MonitorForms;
}();

exports.default = MonitorForms;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MonitorForms2 = require('./MonitorForms');

var _MonitorForms3 = _interopRequireDefault(_MonitorForms2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Model class Monitoring
 */
var Monitoring = function (_MonitorForms) {
	_inherits(Monitoring, _MonitorForms);

	function Monitoring($http, $customer, $content, $mobile, $sce, $home_address_order, $form_details, $member_id) {
		_classCallCheck(this, Monitoring);

		var _this = _possibleConstructorReturn(this, (Monitoring.__proto__ || Object.getPrototypeOf(Monitoring)).call(this, $http, $customer, $content, $mobile, $home_address_order, $member_id));

		_this.forms = [];

		for (var detail in $form_details) {
			_this.forms.push({
				name: $content[$form_details[detail]['name']],
				alias: $form_details[detail]['alias'],
				fkey: $form_details[detail]['fkey'],
				icon: $form_details[detail]['icon'],
				count: 0,
				fields: []
			});
		}
		return _this;
	}

	_createClass(Monitoring, [{
		key: 'checkDOBFormat',
		value: function checkDOBFormat($string) {}
	}, {
		key: 'getMonitoredDetails',
		value: function getMonitoredDetails() {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/get_monitored_details/', { data: 'Show this now' }, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getIdentityRiskDetails',
		value: function getIdentityRiskDetails() {
			return new Promise(function (resolve, reject) {
				$.get('/user/get-risk-details', function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getAssetData',
		value: function getAssetData() {
			var _this2 = this;

			return new Promise(function (resolve, reject) {
				$.get('/user/get-asset-data', function (data) {
					for (var i in data) {
						for (var key in _this2.forms) {
							if (_this2.forms[key].fkey == i) {
								var data_count = {};

								for (var k in data[i]) {
									if (data_count[data[i][k].sd_id] === undefined) {
										data_count[data[i][k].sd_id] = 0;
									}

									data_count[data[i][k].sd_id] += 1;
								}

								_this2.forms[key].count = Object.keys(data_count).length;

								if (data[i].length > 0) {
									for (var fkey in data[i]) {
										if (_this2.forms[key].fields[data[i][fkey].sd_id] === undefined) {
											_this2.forms[key].fields[data[i][fkey].sd_id] = [];
										}

										for (var f in data[i][fkey]) {
											_this2.forms[key].fields[data[i][fkey].sd_id][f] = data[i][fkey][f];
										}
									}
								}
							}
						}
					}

					resolve({
						forms: _this2.forms,
						risk_details: data.risk_details,
						monitor_details: data.monitor_details
					});
				});
			});
		}
	}, {
		key: 'addAssetData',
		value: function addAssetData(post_details) {
			return new Promise(function (resolve, reject) {
				$.post('/user/add-asset-data', post_details, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'updateAssetData',
		value: function updateAssetData(post_details) {
			return new Promise(function (resolve, reject) {
				$.post('/user/update-asset-data', post_details, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'deleteAssetData',
		value: function deleteAssetData(post_details) {
			return new Promise(function (resolve, reject) {
				$.post('/user/delete-asset-data', post_details, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'updateScanResultSurvive',
		value: function updateScanResultSurvive(post_details) {
			return new Promise(function (resolve, reject) {
				$.post('/user/update_scan_result_survive', post_details, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'ignoreScanRecord',
		value: function ignoreScanRecord(post_details) {
			return new Promise(function (resolve, reject) {
				$.post('/user/ignore_scan_record/', post_details, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getScanData',
		value: function getScanData() {
			return new Promise(function (resolve, reject) {
				$.get('/user/portal/get_scan_data/', function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'add_edit_forms',
		value: function add_edit_forms() {
			var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

			if (index !== undefined) {
				return this.forms[index];
			}

			return this.forms;
		}
	}, {
		key: 'monitoring_page',
		value: function monitoring_page() {}
	}, {
		key: 'download_page',
		value: function download_page() {}
	}, {
		key: 'faqs_page',
		value: function faqs_page() {}
	}, {
		key: 'personal',
		value: function personal() {}
	}, {
		key: 'financial',
		value: function financial() {
			return '<div>\n\t\t\t\t\t<div class="flaticon-letter-x primary-blue-color"></div>\n\t\t\t\t\t<h3>Add/Edit Your Financial Details</h3>\n\t\t\t\t\t<p>We keep a close watch on bank account and card numbers to help keep them for your eyes only.</p>\n\t\t\t\t\t<h4 class="col-md-10">Credit Card Numbers</h4>\n\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Card Type</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="card_type" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Card Number</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="card_number" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Expirey Date</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="expirey_date" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>';
		}
	}, {
		key: 'contact',
		value: function contact() {
			return '<div>\n\t\t\t\t\t<div class="flaticon-letter-x primary-blue-color"></div>\n\t\t\t\t\t<h3>Add/Edit Your Contact Details</h3>\n\t\t\t\t\t<h4 class="col-md-10">Home Address</h4>\n\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>House Number</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="house_number" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Street Name</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="street_name" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Additional Address</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="additional_address" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>City</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="city" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t\t<label>Post Code</label>\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="post_code" value="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<h4 class="col-md-10">Email Accounts</h4>\n\t\t\t\t<div class="row">\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t<label>Email Address 1</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="email_address_1" value="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<h4 class="col-md-10">Phone Number</h4>\n\t\t\t\t<div class="row">\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t<label>Landline</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="landline" value="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="form-group col-md-6">\n\t\t\t\t\t\t<div class="col-md-10">\n\t\t\t\t\t\t\t<label>Mobile</label>\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="mobile" value="" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>';
		}
	}]);

	return Monitoring;
}(_MonitorForms3.default);

exports.default = Monitoring;

},{"./MonitorForms":7}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class ResolutionCenter
 */
var ResolutionCenter = function () {
	function ResolutionCenter(initial_list, $content, $sce) {
		_classCallCheck(this, ResolutionCenter);

		this.initial_list = initial_list;
		this.content = $content;
		this.sce = $sce;
	}

	_createClass(ResolutionCenter, [{
		key: 'getInitialList',
		value: function getInitialList() {
			return this.initial_list;
		}
	}, {
		key: 'getRequestList',
		value: function getRequestList() {
			var list = [];

			for (var i in this.content) {
				if (i.indexOf('request-assistance-list') != -1) {
					list.push(this.content[i]);
				}
			}

			return list;
		}
	}, {
		key: 'requestCallPost',
		value: function requestCallPost($post) {
			return new Promise(function (resolve, reject) {
				$.post('/user/assistance/request-a-call', $post, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'resolveSelectSecond',
		value: function resolveSelectSecond(group_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { group_id: group_id }, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getGroupById',
		value: function getGroupById(group_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { group_id: group_id }, function (data) {
					resolve(data);
				});
			});
		}
	}, {
		key: 'getArticle',
		value: function getArticle(article_id) {
			return new Promise(function (resolve, reject) {
				$.post('/user/portal/resolution_center_post/', { article_id: article_id }, function (data) {
					resolve(data);
				});
			});
		}
	}]);

	return ResolutionCenter;
}();

exports.default = ResolutionCenter;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Model class User
 */
var User = function () {
    function User($http) {
        _classCallCheck(this, User);

        this.http = $http;
    }

    _createClass(User, [{
        key: 'getUserDetails',
        value: function getUserDetails() {
            return new Promise(function (resolve, reject) {
                resolve('This is coming from the user class get.');
            });
        }
    }, {
        key: 'login',
        value: function login(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/loginpost', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'checkMembership',
        value: function checkMembership(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/check_membership', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'register',
        value: function register(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/registerpost', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/forgot-password', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(data, url) {
            return new Promise(function (resolve, reject) {
                $.post(url, data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'setGuestPassword',
        value: function setGuestPassword(data, url) {
            return new Promise(function (resolve, reject) {
                $.post(url, data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'updateProfile',
        value: function updateProfile(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/my-account/update-profile', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'changePassword',
        value: function changePassword(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/change-password-post', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'samlAcceptTerms',
        value: function samlAcceptTerms(data) {
            return new Promise(function (resolve, reject) {
                $.post('/user/saml/policy-accepted', data, function (data) {
                    resolve(data);
                });
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            return new Promise(function (resolve, reject) {});
        }
    }]);

    return User;
}();

exports.default = User;

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Abstract class Software
 */
var Software = function () {
    function Software($sce, $content, $deviceDisplayCount) {
        _classCallCheck(this, Software);

        this.software = this.deviceDisplayType($deviceDisplayCount);
    }

    _createClass(Software, [{
        key: 'deviceDisplayType',
        value: function deviceDisplayType($deviceDisplayCount) {
            var devices = {
                'pc': [],
                'mac': [],
                'mobile': []
            };

            for (var device in devices) {
                var icon_screen = device == 'pc' || device == 'mac' ? 'flaticon-laptop-1' : 'flaticon-smartphone-1';

                if ($deviceDisplayCount > 3) {
                    for (var i = 0; i < 2; i++) {
                        devices[device].push({
                            icon_screen: icon_screen,
                            icon_locked: 'fa fa-lock',
                            icon_unlocked: 'fa fa-unlock-alt',
                            device_name: '',
                            installs: 0
                        });
                    }
                } else {
                    for (var i = 0; i < 3; i++) {
                        devices[device].push({
                            icon_screen: icon_screen,
                            icon_locked: 'fa fa-lock',
                            icon_unlocked: 'fa fa-unlock-alt',
                            device_name: '',
                            protected: false
                        });
                    }
                }
            }

            return devices;
        }
    }, {
        key: 'setProtectedSoftware',
        value: function setProtectedSoftware(device_type) {
            var data = {
                pc: {
                    title: this.content['download-pc-images-title'],
                    available: parseInt(this.software.pc.length),
                    device: this.software.pc,
                    display: false,
                    copy: this.$sce.trustAsHtml(this.getDownloadData('pc'))
                },
                mac: {
                    title: this.content['download-pc-images-title'],
                    available: parseInt(this.software.mac.length),
                    device: this.software.mac,
                    display: false,
                    copy: this.$sce.trustAsHtml(this.getDownloadData('pc'))
                },
                mobile: {
                    title: this.content['download-mobile-images-title'],
                    available: parseInt(this.software.mobile.length),
                    device: this.software.mobile,
                    display: false,
                    copy: this.$sce.trustAsHtml(this.getDownloadData('mobile'))
                }
            };

            for (var i in data) {
                if (i == device_type) {
                    data[i].display = true;
                }

                for (var a in this.software[i]) {
                    if (this.software[i][a].protected) {
                        data[i].available -= 1;
                    }
                }
            }

            return data;
        }
    }]);

    return Software;
}();

exports.default = Software;
;

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormatHTML = function () {
	function FormatHTML() {
		_classCallCheck(this, FormatHTML);
	}

	_createClass(FormatHTML, [{
		key: 'contruct',
		value: function contruct() {}
	}, {
		key: 'showString',
		value: function showString(input) {
			var newInput = input,
			    markup = this.formatMarkup(),
			    pattern;

			if (newInput !== undefined) {
				for (var i in markup) {
					if (i != '{{{a' && i != '{{{div' && i != '{{{i') {
						var regex = new RegExp(i, 'gi');

						newInput = newInput.replace(regex, markup[i]);
					}

					if (i == '{{{div') {
						pattern = /{{{div/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}

					if (i == '{{{a') {
						pattern = /{{{a/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}

					if (i == '{{{i') {
						pattern = /{{{i/g;

						newInput = this.formatInternalMarkUp(pattern, newInput, i);
					}
				}
			}

			return newInput;
		}
	}, {
		key: 'formatInternalMarkUp',
		value: function formatInternalMarkUp(pattern, newInput, key) {
			var matches = newInput.match(pattern);

			for (var a in matches) {
				var sLink = newInput.substr(newInput.indexOf(key), newInput.length);

				sLink = sLink.substr(0, sLink.indexOf('}}}') + 3);

				var newLink = '<' + sLink.substr(3, sLink.indexOf('}}}') - 3) + '>',
				    regex = new RegExp(sLink, 'gi');

				newInput = newInput.replace(regex, newLink);
			}

			return newInput;
		}
	}, {
		key: 'formatMarkup',
		value: function formatMarkup() {
			return {
				'{{{p}}}': '<p>',
				'{{{\/p}}}': '</p>',
				'{{{h4}}}': '<h4>',
				'{{{\/h4}}}': '</h4>',
				'{{{u}}}': '<u>',
				'{{{\/u}}}': '</u>',
				'{{{ul}}}': '<ul>',
				'{{{ol}}}': '<ol>',
				'{{{li}}}': '<li>',
				'{{{\/li}}}': '</li>',
				'{{{\/ul}}}': '</ul>',
				'{{{\/ol}}}': '</ol>',
				'{{{strong}}}': '<strong>',
				'{{{\/strong}}}': '</strong>',
				'{{{br}}}': '<br />',
				'{{{a': '',
				'{{{\/a}}}': '</a>',
				'{{{i': '',
				'{{{\/i}}}': '</i>',
				'{{{div': '',
				'{{{\/div}}}': '</div>',
				'{{{table}}}': '<table>',
				'{{{\/table}}}': '</table>',
				'{{{thead}}}': '<thead>',
				'{{{\/thead}}}': '</thead>',
				'{{{th}}}': '<th>',
				'{{{\/th}}}': '</th>',
				'{{{td}}}': '<td>',
				'{{{\/td}}}': '</td>',
				'{{{tr}}}': '<tr>',
				'{{{\/tr}}}': '</tr>',
				'{{{tbody}}}': '<tbody>',
				'{{{\/tbody}}}': '</tbody>'
			};
		}
	}]);

	return FormatHTML;
}();

exports.default = FormatHTML;

},{}]},{},[3])

